import {
  Feedback,
  TypeArray,
  Jump,
  QuestionTargetType,
  QuestionTargetSubType
} from "../types"
import { reducerTypeGuard } from "../reducers/reducerGuards"
import { actionCreatorTypeGuard } from "../reducers/actionCreators"

export type QuestionTarget = {
  id: string
  type: QuestionTargetType
  subType: QuestionTargetSubType
}

const reducerAction = {
  id: actionCreatorTypeGuard<QuestionTarget, string>("id", "QuestionTarget"),
  type: actionCreatorTypeGuard<QuestionTarget, QuestionTargetType>(
    "type",
    "QuestionTarget"
  ),
  subType: actionCreatorTypeGuard<QuestionTarget, QuestionTargetSubType>(
    "subType",
    "QuestionTarget"
  ),
  __record: actionCreatorTypeGuard<TypeArray, QuestionTarget>(
    "QuestionTarget",
    "__record"
  ),
  __create: actionCreatorTypeGuard<TypeArray, null | Partial<QuestionTarget>>(
    "create",
    "__create/QuestionTarget"
  ),
  __delete: actionCreatorTypeGuard<TypeArray, number>("delete", "__record")
}

// Type safety to ensure we have a defined action for each property
type ReducerActions = {
  [key in
    | keyof QuestionTarget
    | "__record"
    | "__delete"
    | "__create"]: (typeof reducerAction)[key][0]
}

// Our exported actions
export const questionTargetAction = Object.fromEntries(
  Object.entries(reducerAction).map(k => [k[0], k[1][0]])
) as ReducerActions

export const questionTargetReducer = reducerTypeGuard<QuestionTarget>()
  .case(...reducerAction.id)
  .case(...reducerAction.type)
  .case(...reducerAction.subType)
  .build()
